module.exports = __webpack_public_path__ + "images/liinilaevad/routes/TAL-NAI-TAL@2x.png";